// @ts-check

import angular from 'angular';

import rcmGuid from './rcm-guid';

/**
 * rcmGuid Service
 * - Shared service
 */
angular.module('RcmJsLib').service('rcmGuid', function () {
  return rcmGuid;
});
